import React, { useEffect, useState } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import BarLineCharts from "./BarLineCharts";
import css from "../../common/anomalyMagneticStyle.less";
import { getcircuitUsagePayload } from "../../../../../../config/reqConfig/anomalyDetection.js";
import ApiService from "../../../../../../config/api-config.js";
import {
  backtoSevenDays,
  convertTsToLocal,
  displayDateTime,
  displayPathAnalyticsTime,
} from "../../../../../../utils/displayTime.js";
import Spinner from "../../../../../../common/Spinner";
import NoDataAvailable from "../../../../../../common/NoDataAvailable";
import ErrorComponent from "../../../../../../common/ErrorComponent";
import CustomTimeStamp from "../../../../../../generics/TimeStamp/customTimeStamp";
import { PropTypes } from "prop-types";
import { sitesWidgetVisibility } from "../../common/adUtils.js";
import { reloadQSI } from "../../../../../../utils/common.js";
import useI18n from "../../../../../../i18n/useI18n";

const UsageCircuitsCharts = (props) => {
  const { tViews } = useI18n("views");
  const [HbrTooltip, HbrIcon] = reactWrapper(["hbr-tooltip", "hbr-icon"]);
  const [isLoading, setLoader] = useState(null);
  const [isError, setError] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [timePeriod, setTimeperiod] = useState([]);
  const [selectedHour, setSelectedHour] = useState(null);

  useEffect(() => {
    const storedTab = localStorage.getItem("selectedADTab");
    sitesWidgetVisibility(storedTab);
    return () => {
      props.saveUsageDateForTable("");
    };
  }, []);

  useEffect(() => {
    const runEffect = async () => {
      setLoader(true);
      try {
        let timePeriod = backtoSevenDays();
        setTimeperiod(timePeriod);
        const payload = getcircuitUsagePayload(timePeriod);
        const res = await ApiService.getcircuitUsageCharts(payload);
        if (!res.errorObject) {
          let data = [];
          res.data.data.forEach((d) => {
            let objEntry = {
              entry_ts: convertTsToLocal(d.entry_ts),
            };
            objEntry["Usage"] = d.cellular_usage;
            objEntry["display_cellular_usage"] = d.display_cellular_usage;
            objEntry["Anomalous Circuits"] = d.perc_anomalous_cellular_circuits;
            objEntry["anomalous_circuits_cnt"] =
              d.cellular_anomalous_circuit_cnt;
            objEntry["anomalous_circuits_total_cnt"] = d.cellular_circuit_cnt;
            data.push(objEntry);
          });
          setChartData(data);
          let hour = data.length > 0 ? data[data.length - 2].entry_ts : null;
          props.saveUsageDateForTable(displayPathAnalyticsTime(hour));
          setSelectedHour(displayPathAnalyticsTime(hour));
          // Load Qualtrics Intercept.
          reloadQSI();
        } else {
          setError(res.errorObject);
        }
      } catch (error) {
        setError(error.message);
      }
      setLoader(false);
    };

    runEffect();
  }, [props.refresh]);

  return (
    <div role="region" aria-label={tViews("usageBasedAD.usageHeader")}>
      <div>
        {isLoading ? (
          <Spinner />
        ) : isError ? (
          <ErrorComponent error={isError} />
        ) : chartData.length > 0 ? (
          <div>
            <div className={css["usage-ad-title"]}>
              <div className="header">
                {tViews("usageBasedAD.usageHeader")}
                <span className={"ad-cellular-widget-tooltip"}>
                  <HbrTooltip hoist>
                    <div slot="content">
                      <span>{tViews("usageBasedAD.usageHeaderInfoTip")}</span>
                    </div>
                    <HbrIcon
                      name="info"
                      sentiment="neutral"
                      aria-label={tViews("a11yLabels.infoAboutremoteSites")}
                      tabIndex="0"
                      role="button"
                    ></HbrIcon>
                  </HbrTooltip>
                </span>
              </div>
              <div id="va-ad-usage-qualtrics-container">
                {/* The Qualtrics Thumbs Up and Thumbs Down survey widget for the AD Usage page is rendered here */}
              </div>
              <div className="timestamp">
                <CustomTimeStamp
                  prevTime={displayDateTime(timePeriod[0])}
                  currentTime={displayDateTime(timePeriod[1])}
                />
                <div className="ad-timePeriodTxt">
                  {tViews("app360.afHeatmapTimePriodText")}
                </div>
              </div>
            </div>
            <BarLineCharts
              id="usage-circuits-charts"
              data={chartData}
              selectedBar={selectedHour}
              saveData={props.saveUsageDateForTable}
              timePeriod={timePeriod}
            />
          </div>
        ) : (
          <NoDataAvailable />
        )}
      </div>
    </div>
  );
};

UsageCircuitsCharts.propTypes = {
  refresh: PropTypes.bool,
  adKey: PropTypes.object,
  saveUsageDateForTable: PropTypes.func.isRequired,
};

export default UsageCircuitsCharts;
